<ng-container *ngIf="displayModel">
  <div
    class="events-item-cell event-type event-time"
    [ngClass]="{ 'event-in-progress': displayModel.eventType === 'In progress' }"
    [innerText]="displayModel.eventType"
  ></div>
  <div class="events-item-cell events-item-link-color">
    <link-indicator
      class="events-item-cell"
      *ngIf="displayModel.linkColor"
      [color]="displayModel.linkColor"
      [name]="displayModel.linkName"
    ></link-indicator>
  </div>
  <div class="events-item-cell">
    <div class="events-item-name">
      <div class="events-item-title">
        <a class="title-text" [innerHTML]="displayModel.title.text"></a>
        <div class="details">
          <div class="time" *ngIf="displayModel.time">{{ displayModel.time }}</div>
          <div class="dot" *ngIf="displayModel.rsvp">•</div>
          <div class="rsvp" *ngIf="displayModel.rsvp">
            {{ displayModel.rsvp }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="events-item-cell events-item-actions">
    <home-actions
      #actions
      *ngIf="displayModel.actions"
      (onAction)="onAction($event, 'mouse_click')"
      [items]="displayModel.actions"
      class="actions"
    >
    </home-actions>
  </div>
</ng-container>
